const DEBOUNCE_TIME = 3000;
const MAX_WAIT_TIME = 10000;

export const createVideoAnalyzingToastAggregator = ({
  debounceTime = DEBOUNCE_TIME,
  maxWaitTime = MAX_WAIT_TIME,
} = {}) => {
  const assetsById = new Map();
  let debounceTimer = null;
  let maxWaitTimer = null;
  let flushCallback = null;

  const clearTimers = () => {
    clearTimeout(debounceTimer);
    clearTimeout(maxWaitTimer);
    debounceTimer = null;
    maxWaitTimer = null;
  };

  const clear = () => {
    clearTimers();
    assetsById.clear();
    flushCallback = null;
  };

  const flush = () => {
    if (!assetsById.size || !flushCallback) return;

    const assets = Array.from(assetsById.values());
    const callback = flushCallback;
    clear();
    callback(assets);
  };

  const add = (assets, onFlush) => {
    assets.forEach((asset) => {
      if (asset?._id) assetsById.set(asset._id, asset);
    });

    if (!assetsById.size) return;

    flushCallback = onFlush;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(flush, debounceTime);

    if (!maxWaitTimer) {
      maxWaitTimer = setTimeout(flush, maxWaitTime);
    }
  };

  return { add, clear, flush };
};

export default createVideoAnalyzingToastAggregator();
